import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MainRoutingModule } from "./main-routing.module";
import { MainComponent } from "./main.component";
import { HeaderComponent } from "./../header/header.component";
import { HomeComponent } from "./../home/home.component";
import { AboutComponent } from "../about/about.component";
import { PortfolioComponent } from "../portfolio/portfolio.component";
import { FooterComponent } from "../footer/footer.component";
import { ContactComponent } from '../contact/contact.component';

@NgModule({
  declarations: [
    MainComponent,
    HeaderComponent,
    HomeComponent,
    AboutComponent,
    PortfolioComponent,
    FooterComponent,
    ContactComponent,
  ],
  imports: [CommonModule, MainRoutingModule],
})
export class MainModule {}
